var exports = {
  "container": "MediaTimeDisplay.module__container___dmh0WG",
  "time": "MediaTimeDisplay.module__time___dmh0WG",
  "separator": "MediaTimeDisplay.module__separator___dmh0WG",
  "small": "MediaTimeDisplay.module__small___dmh0WG",
  "medium": "MediaTimeDisplay.module__medium___dmh0WG",
  "large": "MediaTimeDisplay.module__large___dmh0WG",
  "compact": "MediaTimeDisplay.module__compact___dmh0WG",
  "duration": "MediaTimeDisplay.module__duration___dmh0WG",
};

__webpack_require__.r(module.exports = exports);
